"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveFindFolder = exports.googleDriveFindFolderResultSchema = exports.googleDriveFindFolderArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveFindFolderArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('find-folder', zod_1.z.object({
    nameSearchTerm: zod_1.z.string().describe("The folder's name to be found"),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
});
exports.googleDriveFindFolderResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(googleDriveFileSchema));
exports.googleDriveFindFolder = (0, common_1.createToolMetadata)({
    id: 'googleDriveFindFolder',
    displayName: 'Google Drive Find Folder',
    displayDescription: 'Find a folder by name in Google Drive',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveFindFolderArgsSchema,
}, exports.googleDriveFindFolderResultSchema);
